import {
    useEffect,
    useState,
} from 'react';

// FNP-1193 — the keyword search, module-scoped for the same reason the zones
// and records modules' are (FNP-815): the search input lives inside the table
// component and the hook that filters on the keyword is a different component.
// A local useState would give each its own copy and search would silently do
// nothing.
//
// Do not replace with a local useState.
//
// ⚠️ CLIENT-SIDE, AND THERE IS NO ALTERNATIVE. `listCertificates` takes only
// `limit` and `nextToken` — no filter argument of any kind — so the keyword
// narrows the LOADED WINDOW. The footer says which scope its count refers to.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

// Test-only reset. The store outlives a component tree by design, which means
// it also outlives a test case — without this, a keyword set in one test leaks
// into the next.
export const resetCertificatesSearch = () => {
    globalKeyword = '';
    keywordListeners.clear();
};

export const useCertificatesSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        // A consumer mounting after the keyword was set must not start from ''.
        setKeyword(globalKeyword);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    return {
        keyword,
        handleFilterByKeyword: (newKeyword: string) => notifyKeywordChange(newKeyword),
    };
};
